import { useRunOnce } from '@fabric-app/hooks/useRunOnce';
import { useColorScheme } from '@fabric-app/ui/theme/useColorScheme';
import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas';
import { useEffect, useState } from 'react';

/**
 *
 */
export const useThemedRive = ({ stateMachine, src }: { stateMachine: string; src: string }) => {
  const [isRiveLoaded, setIsRiveLoaded] = useState(false);

  const { rive, setCanvasRef } = useRive({
    src,
    stateMachines: stateMachine,
    layout: new Layout({ fit: Fit.Cover, alignment: Alignment.Center }),
    autoplay: true,
    onLoad: () => {
      setIsRiveLoaded(true);
    },
  });

  useRunOnce(
    () => {
      rive!.resizeDrawingSurfaceToCanvas();
    },
    {
      condition: !!rive && isRiveLoaded,
    },
  );

  const { parsedColorScheme } = useColorScheme();

  // toggle between dakr and light mode
  useEffect(() => {
    if (!rive) return;
    const inputs = rive.stateMachineInputs(stateMachine);
    const darkModeInput = inputs?.find((input) => input.name === 'darkMode');
    if (!darkModeInput) return;
    darkModeInput.value = parsedColorScheme === 'dark';
  }, [rive, parsedColorScheme]);

  return {
    setCanvasRef,
    isRiveLoaded,
  };
};
